import { createActions } from 'utils/actions';

/**
 * Redux actions for fetching the company's branding.
 *
 * @type {Object}
 */
export const fetchBranding = createActions('branding', 'FETCH_BRANDING');

/**
 * Redux actions for resetting the company's branding back to the default Mineral branding.
 *
 * @type {Object}
 */
export const resetBranding = createActions('branding', 'RESET_BRANDING');
